import { graphConfig } from "../authConfig/authConfig";

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(accessToken, email) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  return fetch(graphConfig.graphUserEndpoint + `/${email}`, options)
    .then((response) => response.json())
    .catch((error) => console.log(error));

  // return fetch(graphConfig.graphMeEndpoint, options)
  //   .then((response) => response.json())
  //   .catch((error) => console.log(error));
}
